import { fetchAvailableExportFields } from '@app/services/documentsRepository';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useAvailableExportFields = () => {
  const { t } = useTranslation(['configErrors']);

  return useQuery({
    meta: {
      errorMessage: t('configErrors:export_fields_fetch_failure'),
    },
    queryFn: fetchAvailableExportFields,
    queryKey: ['availableExportFields'],
  });
};
